import { SearchOutlined } from '@ant-design/icons';
import { Button, Drawer, Space, theme } from 'antd';
import { useTranslation } from 'react-i18next';
import AgentStatusDropdown from '../../../../components/AgentStatusDropdown';
import RightTopMenu from '../../../../components/RightTopMenu';
import CallAppContainer from '../../../../components/plugins/CallAppContainer';
import ChatAppContainer from '../../../../components/plugins/chat/ChatAppContainer';
import useToggle from '../../../../hooks/useToggle';
import JobFeedbackContainer from '../../../JobFeedbackContainer';
import SearchDrawerContainer from './SearchDrawerContainer';

export default function RightTopActions() {
    const {
        token: { zIndexPopupBase }
    } = theme.useToken();
    const [isDrawerOpen, , openDrawer, closeDrawer] = useToggle(false);
    const { t } = useTranslation('common');

    return (
        <>
            <Space size="small" style={{ marginRight: 10 }} align="center">
                <AgentStatusDropdown />
                <ChatAppContainer />
                <CallAppContainer />
                <JobFeedbackContainer />
                <Button icon={<SearchOutlined />} style={{ backgroundColor: 'transparent' }} onClick={openDrawer} />
                <RightTopMenu />
            </Space>
            <Drawer
                title={t('searchTickets')}
                placement="right"
                closable={true}
                onClose={closeDrawer}
                open={isDrawerOpen}
                width={700}
                autoFocus={false} // It defaults to true and it steals focus from search input
                zIndex={zIndexPopupBase + 30 + 2} // zIndexPopupBase + 30 (default popover z-index) + 2 (place over PluginApp component)
            >
                <SearchDrawerContainer closeDrawer={closeDrawer} open={isDrawerOpen} />
            </Drawer>
        </>
    );
}
